<div mat-dialog-content class="share-dialog-content">
  <button mat-icon-button class="close-btn" (click)="close()" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
  <h2 class="dialog-title">Share this app</h2>
  <div class="qr-container">
    <qrcode [qrdata]="referralLink" [width]="200" [errorCorrectionLevel]="'M'"></qrcode>
  </div>
  <mat-form-field appearance="outline" class="referral-input">
    <mat-label>Referral Link</mat-label>
    <input matInput [value]="referralLink" disabled>
  </mat-form-field>
  <div class="button-row">
    <button mat-raised-button color="primary" (click)="copyLink()">
      <mat-icon>content_copy</mat-icon> Copy Link
    </button>
    <button mat-raised-button color="accent" (click)="share()">
      <mat-icon>share</mat-icon> Share
    </button>
  </div>
</div>
